import React from 'react'
import { DatePicker } from 'components/datePicker'
import { FilterOptions } from './filterOptions'

export const DateFilter = ({ localize, column, update, classes }) => {
  const { option } = column
  const showPicker = option.id !== 'isnull' && option.id !== 'isnotnull'
  const handleOnChange = React.useCallback((value) => update({ value }), [update])
  return (
    <div>
      <FilterOptions localize={localize} classes={classes} column={column} update={update} />
      {showPicker && <DatePicker value={column.value} onChange={handleOnChange} />}
    </div>
  )
}